<template>
  <div>
    <div v-for="(item, index) in warnings" :key="index">
      <v-alert value="true" type="error">{{ item }}</v-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppRequirementCheck",
  data: () => ({
    warnings: [],
  }),
  mounted() {
    if (!this.isAvailableCookies()) {
      this.warnings.push("This site requires cookies to function properly");
    }
    if (!this.isAvailableJson()) {
      this.warnings.push("This site requires JSON to function properly");
    }
    if (!this.isAvailableLocalStorage()) {
      this.warnings.push(
        "This site requires local storage to function properly"
      );
    }
    if (!this.isAvailableSessionStorage()) {
      this.warnings.push(
        "This site requires session storage to function properly"
      );
    }
    if (!this.isAvailableWebGL()) {
      this.warnings.push("This site requires WebGL to function properly");
    }
  },
};
</script>

<style scoped>
.v-alert {
  margin-top: 0px;
}
</style>
